import { buildDateField } from './date-field/date-field.js';
import { buildDateRangeField, } from './date-range-field/date-range-field.js';
import { buildExactMatch, } from './exact-match/exact-match.js';
import { buildFieldExists, } from './field-exists/field-exists.js';
import { buildKeyword } from './keyword/keyword.js';
import { buildNear } from './near/near.js';
import { buildNumericField, } from './numeric-field/numeric-field.js';
import { buildNumericRangeField, } from './numeric-range-field/numeric-range-field.js';
import { buildQueryExtension, } from './query-extension/query-extension.js';
import { buildStringFacetField, } from './string-facet-field/string-facet-field.js';
import { buildStringField, } from './string-field/string-field.js';
/**
 * Creates an `QueryExpression` instance.
 *
 * @param config - The expression builder options.
 * @returns An `QueryExpression` instance.
 */
export function buildQueryExpression() {
    const parts = [];
    let booleanOperator = 'and';
    return {
        addExpression(expression) {
            parts.push(expression);
            return this;
        },
        addKeyword(expression) {
            parts.push(buildKeyword(expression));
            return this;
        },
        addNear(expression) {
            parts.push(buildNear(expression));
            return this;
        },
        addExactMatch(expression) {
            parts.push(buildExactMatch(expression));
            return this;
        },
        addFieldExists(expression) {
            parts.push(buildFieldExists(expression));
            return this;
        },
        addStringField(expression) {
            parts.push(buildStringField(expression));
            return this;
        },
        addStringFacetField(expression) {
            parts.push(buildStringFacetField(expression));
            return this;
        },
        addNumericField(expression) {
            parts.push(buildNumericField(expression));
            return this;
        },
        addNumericRangeField(expression) {
            parts.push(buildNumericRangeField(expression));
            return this;
        },
        addDateField(expression) {
            parts.push(buildDateField(expression));
            return this;
        },
        addDateRangeField(expression) {
            parts.push(buildDateRangeField(expression));
            return this;
        },
        addQueryExtension(expression) {
            parts.push(buildQueryExtension(expression));
            return this;
        },
        joinUsing(operator) {
            booleanOperator = operator;
            return this;
        },
        toQuerySyntax() {
            const symbol = getBooleanOperatorSymbol(booleanOperator);
            const expression = parts
                .map((part) => part.toQuerySyntax())
                .join(`) ${symbol} (`);
            return parts.length <= 1 ? expression : `(${expression})`;
        },
    };
}
function getBooleanOperatorSymbol(operator) {
    return operator === 'and' ? 'AND' : 'OR';
}
